<---慧识 一个项目一个链接 -->
<template>
  <div class="container" v-if="isShow">
    <img :src="currentBg" alt="" class="img" />
    <div class="input-container" :class="{ jzs1: shortName == 'jzs1', jzs2: shortName == 'jzs2', aqs: shortName == 'aqs' }">
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入您的手机号，仅开课使用，已加密" v-model="formData.mobile" />
      </div>
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入验证码" v-model="formData.msg" />
        <div class="code" @click="sendMsg">
          获取验证码<span v-if="codeTime != 60">({{ codeTime }})</span>
        </div>
      </div>
      <div class="radio-wrapper" :class="{ aqs: shortName == 'aqs' }">
        <div class="radio-item" v-for="(item, index) in filterList" :key="index" @click="radioChange(index)">
          <img src="@/assets/imgs/check_box_selected.png" v-if="item.isSelected" />
          <img src="@/assets/imgs/check_box.png" v-else />
          <span>{{ item.name }}</span>
        </div>
      </div>
      <div class="submit" @click="onsubmit" />
    </div>
  </div>
</template>

<script>
import { enrollPwd, sendMsg } from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      codeTime: 60,
      formData: {
        mobile: '',
        msg: ''
      },
      list: [
        {
          name: '建筑全科',
          shortName: 'jzs1',
          id: 'BK202407030001',
          promotedAccount: '慧识-图书-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '建筑全科',
              worthid: '8bd13e79040a4416af5d77aa7b81b340',
              subjectid: '69e46917cfdf4fa1a103ce044b368051'
            }
          ]
        },
        {
          name: '机电全科',
          shortName: 'jzs1',
          id: 'BK202407030003',
          promotedAccount: '慧识-图书-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '机电全科',
              worthid: '5514ee0d5fdf4f04882ba09ba476d286',
              subjectid: '8c0126ad336c470ab786631fd3a0b64e'
            }
          ]
        },
        {
          name: '市政全科',
          shortName: 'jzs1',
          id: 'BK202407030002',
          promotedAccount: '慧识-图书-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '市政全科',
              worthid: 'c1ad283921964739bcb406b6968462cc',
              subjectid: '7b44758158d24726ab0a3a627c1e4c84'
            }
          ]
        },

        {
          name: '公路全科',
          shortName: 'jzs1',
          id: 'BK202407030004',
          promotedAccount: '慧识-图书-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '公路全科',
              worthid: 'fa9cc21b6dc541e993086a4db30eca66',
              subjectid: 'fb34520de9d046ee93a974f0b1e2642b'
            }
          ]
        },
        {
          name: '水利全科',
          shortName: 'jzs1',
          id: 'BK202407030005',
          promotedAccount: '慧识-图书-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '水利全科',
              worthid: '3b0f58d15d694bc89357eb1ad2927386',
              subjectid: '7a57c2fdc74b465aa3810a456958c781'
            }
          ]
        },
        {
          name: '建筑全科',
          shortName: 'jzs2',
          id: 'BK202401080001',
          promotedAccount: '慧识-图书-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '建筑全科',
              worthid: '9326e649c5a44dcfa9fd2cab14695c37',
              subjectid: '3bdfeeff79834aa08cf1f34f68143cbd'
            }
          ]
        },
        {
          name: '机电全科',
          shortName: 'jzs2',
          id: 'BK202401080001',
          promotedAccount: '慧识-图书-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '机电全科',
              worthid: '0893550b16f84ec886553f2415be9c25',
              subjectid: '0137751bebf94548a39f4c78ab8caa20'
            }
          ]
        },
        {
          name: '市政全科',
          shortName: 'jzs2',
          id: 'BK202401080001',
          promotedAccount: '慧识-图书-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '市政全科',
              worthid: '90a23eb40a544ca381b258bda0ec82b1',
              subjectid: '704086d0180f439d882cb671c232e9ce'
            }
          ]
        },
        {
          name: '公路全科',
          shortName: 'jzs2',
          id: 'BK202401080001',
          promotedAccount: '慧识-图书-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '公路全科',
              worthid: '5cd9865b05514e97af8126a9007c70e3',
              subjectid: '9f6a0901dd8746d3ac6ec25669f05482'
            }
          ]
        },
        {
          name: '水利全科',
          shortName: 'jzs2',
          id: 'BK202401080001',
          promotedAccount: '慧识-图书-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '水利全科',
              worthid: '923ba55013864ddc9534f9dcb1a1510f',
              subjectid: 'dd28111117f141afb53192d079fa2bc0'
            }
          ]
        },
        {
          name: '建筑全科',
          shortName: 'aqs',
          id: 'BK202407030006',
          promotedAccount: '慧识-图书-安工',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '建筑施工安全全科',
              worthid: '2c61060933854dfea04386925a983f06',
              subjectid: '6d50bafdbf2b40ffa4eb85bb861d4ace'
            }
          ]
        },
        {
          name: '化工全科',
          shortName: 'aqs',
          id: 'BK202407030007',
          promotedAccount: '慧识-图书-安工',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '化工安全全科',
              worthid: '4a642ef716c146fea914a9abd003b862',
              subjectid: 'a7c4f50d5ce94eef9ee8880ca2f4cc71'
            }
          ]
        },
        {
          name: '煤矿全科',
          shortName: 'aqs',
          id: 'BK202407030009',
          promotedAccount: '慧识-图书-安工',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '煤矿安全全科',
              worthid: 'dd233f05533a476aaace13e31f692679',
              subjectid: '63a0aa33686b4a56b4477f8696f716e8'
            }
          ]
        },
        {
          name: '其他安全全科',
          shortName: 'aqs',
          id: 'BK202407030008',
          promotedAccount: '慧识-图书-安工',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '其他安全全科',
              worthid: '3b3bbdb363854f9eb75d7ad5f3ee10dc',
              subjectid: '5382d9e80806476999073b88290cac58'
            }
          ]
        },
        {
          name: '道路运输全科',
          shortName: 'aqs',
          id: 'BK202407030012',
          promotedAccount: '慧识-图书-安工',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '道路运输安全全科',
              worthid: '509b85a82686428295cefc3d76171208',
              subjectid: '0d9d3c77fe5b4aabb3c2d8d7da814279'
            }
          ]
        },
        {
          name: '金属冶炼全科',
          shortName: 'aqs',
          id: 'BK202407030011',
          promotedAccount: '慧识-图书-安工',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '金属冶炼全科',
              worthid: 'c962cde79b8b4cb1addd6869696f17e3',
              subjectid: '89f5ce69ccf04c529ac91ed959c695e9'
            }
          ]
        },
        {
          name: '金属非金属全科',
          shortName: 'aqs',
          id: 'BK202407030010',
          promotedAccount: '慧识-图书-安工',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '金属非金属全科',
              worthid: '5d409365726f4e8e868c247d9b16e276',
              subjectid: 'e0eed484583c49a2817a1b9cd225784b'
            }
          ]
        }
      ],
      bgImgList: {
        jzs1: 'https://zk-web-new.oss-cn-beijing.aliyuncs.com/h5/promotion/hsxm/hsxm_jzs1_bg.jpg',
        jzs2: 'https://vodcdn.zhongjianedu.com/image/default/C62274E52191432DB703D284567B7FD0-6-2.jpg',
        aqs: 'https://zk-web-new.oss-cn-beijing.aliyuncs.com/h5/promotion/hsxm/hsxm_aqs_bg.jpg'
      },
      id: '',
      shortName: '',
      currentCourse: {},
      //发送验证码
      isCodeClickable: true,
      isShow: false,
      filterList: []
    }
  },
  methods: {
    radioChange(index) {
      this.filterList.forEach(item => (item.isSelected = false))
      const current = this.filterList[index]
      current.isSelected = true
      this.$set(this.filterList, index, current)
    },
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }
      if (!this.isCodeClickable) {
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.isCodeClickable = false
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
          this.isCodeClickable = true
        }
        this.codeTime = codeTime
      }, 1000)
    },
    onsubmit() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.formData.msg) {
        this.$toast.center('请输入验证码')
        return
      }

      if (!this.filterList.find(item => item.isSelected)) {
        this.$toast.center('请选择科目')
        return
      } else {
        this.currentCourse = this.filterList.find(item => item.isSelected)
      }

      const gt = new Date().getTime().toString()
      enrollPwd({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData,
        classid: this.currentCourse.id,
        subjectid: this.currentCourse.subjectList.map(item => item.subjectid).join(','),
        worthid: this.currentCourse.subjectList.map(item => item.worthid).join(','),
        collegeName: this.currentCourse.collegeName,
        orign: '慧识',
        promotedAccount: `${this.currentCourse.promotedAccount}`
      }).then(res => {
        this.$toast.center('提交成功')
        this.formData.mobile = ''
        this.formData.msg = ''
        setTimeout(() => {
          window.location.href = 'https://www.zhongke3.com/zj-app-h5/mp_toutiao/qscode/1790236487288340480'
        }, 2000)
      })
    }
  },
  created() {
    this.shortName = this.$route.params.name
    this.filterList = this.list.filter(item => item.shortName === this.shortName)
    if (this.filterList.length) {
      this.currentBg = this.bgImgList[this.shortName]
      this.isShow = true
    }
  }
}
</script>
<style>
body {
  min-width: 100%;
}
</style>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100vw;
  &::-webkit-scrollbar {
    display: none;
  }
  .img {
    position: absolute;
    width: 100vw;
    top: 0;
    vertical-align: bottom;
    z-index: 0;
  }
  .input-container {
    position: relative;
    height: 53vw;
    width: 100%;
    z-index: 1;
    &.jzs1 {
      padding: 179vw 0 0;
    }

    &.jzs2 {
      padding: 186vw 0 0;
    }

    &.aqs {
      padding: 189vw 0 0;
    }

    .input-box {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      padding: 0 9.5vw;
      input {
        flex: 1;
        border: none;
        outline: none;
        padding-left: 10px;
        border: 1px solid #f1f8ff;
        border-radius: 4px;
        font-size: 12px;
        height: 41px;
        box-shadow: none;
        background: rgb(243, 244, 246);
      }
      .code {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        color: #fff;
        font-size: 12px;
        width: 99px;
        height: 30px;
        border-radius: 5px;
        background: rgb(27, 102, 203);
        span {
          color: #fff;
        }
      }
    }
    .radio-wrapper {
      display: flex;
      flex-wrap: wrap;
      padding-left: 6vw;
      padding-top: 2.5vw;

      .radio-item {
        display: flex;
        &:not(:last-child) {
          margin-right: 5px;
        }
        img {
          width: 4.5vw;
          height: 4.5vw;
        }
        span {
          font-size: 12px;
          color: #666;
        }
      }
      &.aqs {
        padding-left: 9.5vw;
        padding-top: 0;
        .radio-item {
          margin-right: 0;
          margin-bottom: 1vw;
          width: 28vw;
          &:nth-child(5) {
            width: 35vw;
          }
        }
      }
    }

    .submit {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      margin: 21px auto 0;
      color: #fff;
      font-size: 14px;
      border-radius: 2px;
      height: 100%;
      width: 90%;
      background: none;
    }
  }
}
</style>
